import { Link } from 'react-router-dom';
import { StatusBadge } from './StatusBadge.jsx';
import { ProgressBar } from './ProgressBar.jsx';
import { projectProgress, statusTone } from '../utils/statusUi.js';

export function ProjectHero({
  breadcrumb,
  name,
  subtitle,
  status,
  statusLabel,
  statusTone: statusToneProp,
  progress,
  meta = [],
  actions,
}) {
  const percent = progress ?? projectProgress(status);
  const tone = statusToneProp || (statusTone(status) === 'success' ? 'success' : statusTone(status) === 'danger' ? 'danger' : 'info');

  return (
    <div className="project-hero">
      {breadcrumb ? <div className="project-hero-crumb">{breadcrumb}</div> : null}
      <div className="project-hero-row">
        <div className="project-hero-identity">
          <div className="project-hero-mark" aria-hidden>
            {(name || 'P').slice(0, 1).toUpperCase()}
          </div>
          <div>
            <div className="project-hero-title-row">
              <h2 className="project-hero-title" data-tour="page-title">
                {name}
              </h2>
              {status ? <StatusBadge status={status} label={statusLabel} tone={statusToneProp} /> : null}
            </div>
            {subtitle ? <p className="muted small" style={{ margin: 0 }}>{subtitle}</p> : null}
          </div>
        </div>
        {actions ? <div className="project-hero-actions">{actions}</div> : null}
      </div>
      <ProgressBar value={percent} tone={tone} label={`${percent}% complete`} />
      {meta.length ? (
        <div className="project-hero-meta">
          {meta.map((item) => (
            <div key={item.label} className="project-hero-meta-item">
              <span className="eyebrow">{item.label}</span>
              <strong>
                {item.to ? <Link to={item.to}>{item.value}</Link> : item.value}
              </strong>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
